import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getHistory } from "./historyAPI";
import { BetResult } from "./types";

export interface BettingState {
  betResults: BetResult[];
  status: "idle" | "loading" | "failed" | "succeeded";
}

const initialState: BettingState = {
  betResults: [],
  status: "idle",
};

export const getHistoryAsync = createAsyncThunk(
  "history/getHistory",
  async () => {
    return await getHistory();
  }
);

export const wagersSlice = createSlice({
  name: "betting",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(getHistoryAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getHistoryAsync.fulfilled, (state, action) => {
        state.status = "idle";
        state.betResults = action.payload;
      });
  },
});

// export const {} = wagersSlice.actions;

export default wagersSlice.reducer;
